import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectFilter,
  selectTransactions,
} from "../Redux/slices/transactionState";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import BillPDF from "../components/BillPDF";
import { selectParties } from "../Redux/slices/partyState";

export default function PrintBill() {
  const transactions = useSelector(selectTransactions);
  const [summary, setSummary] = useState({
    totalQuantity: 0,
    totalBill: 0,
    totalPaid: 0,
  });
  function calculateSummary(summary, t) {
    if (!summary)
      return {
        quantity: {},
        totalBill: 0,
      };
    console.log(summary.quantity);
    if (summary.quantity[t.unit]) {
      summary.quantity[t.unit] += parseInt(t.quantity);
    } else {
      summary.quantity[t.unit] = parseInt(t.quantity);
    }
    summary.totalBill = summary.totalBill + parseInt(t?.bill||0);
    return summary;
  }

  const partyList = useSelector(selectParties);
  const filteredParty = useSelector(selectFilter);
  let partyDetails = [
    {
      name: "",
      firm: "",
      mobile: "",
      address: "",
    },
  ];
  if (filteredParty.party) {
    partyDetails = partyList.filter((data) => {
      //console.log({name:data?.name?.trim() , party:filteredParty.party, result: data?.name?.trim() === filteredParty?.party?.trim()  })
      return data?.name?.trim() === filteredParty?.party?.trim();
    });
  }
  useEffect(() => {
    const summaryTemp = transactions.reduce(calculateSummary, {
      quantity: {},
      totalBill: 0,
      totalPaid: 0,
    });
    summaryTemp.quantity = Object.entries(summaryTemp.quantity).map(
      ([key, value]) => ({ key, value })
    );
    setSummary({ ...summaryTemp });
  }, [transactions]);
  return (
    <div className="flex flex-col">
      <PDFDownloadLink
        className="px-4 py-3 bg-indigo-600 text-white rounded mx-auto my-4"
        document={
          <BillPDF
            partyDetails={partyDetails}
            records={transactions}
            summary={summary}
            filter={filteredParty}
          />
        }
        fileName="somename.pdf"
      >
        {({ blob, url, loading, error }) =>
          loading ? "Loading document..." : "PDF is ready to Download now!"
        }
      </PDFDownloadLink>

      <PDFViewer className="w-full h-screen">
        <BillPDF
          partyDetails={partyDetails}
          records={transactions}
          summary={summary}
          filter={filteredParty}
        />
      </PDFViewer>
    </div>
  );
}
